<template>
  <component :is="component"></component>
</template>
<script>
import Func137RecuperarSenha from '@/views/137/Func137RecuperarSenha'

export default {
  name: 'Func137',
  data () {
    return {
      component: Func137RecuperarSenha
    }
  }
}
</script>
